/* ─────────────────────────────────────────────────────────────────────────────
   Sockologie — shared live-agents availability status.

   Drives any element carrying [data-sk-agent-status]:
     • sets the CSS variable --sk-agent-rgb (used for the status dot color)
     • adds a state class: sk-agent--online | --afterhours | --limited | --closed
     • writes the status copy into its [data-sk-agent-text] descendant

   States (all evaluated in America/Los_Angeles so PST/PDT is automatic):
     green  — Mon-Fri 8:00am-4:30pm PT
     amber  — after hours / weekends, and minor holidays (Jul 4, Memorial, Labor)
     red    — full-closure holidays (Christmas Eve/Day, New Year's Eve/Day, Thanksgiving)
   ──────────────────────────────────────────────────────────────────────────── */
(function () {
  // Already initialized (e.g. loaded on a page that includes it twice)? Just re-apply.
  if (window.SK_AGENT_STATUS) { window.SK_AGENT_STATUS.apply(); return; }

  // Business hours (Pacific), in minutes from midnight
  var OPEN_MIN  = 8 * 60;        // 08:00
  var CLOSE_MIN = 16 * 60 + 30;  // 16:30

  var STATES = {
    online:     { key: 'online',     rgb: '74 222 128', copy: 'CUSTOMER SERVICE AGENTS ONLINE' },
    afterhours: { key: 'afterhours', rgb: '245 179 1',  copy: 'AFTER HOURS, LIMITED AVAILABILITY' },
    limited:    { key: 'limited',    rgb: '245 179 1',  copy: 'HOLIDAY HOURS, LIMITED AVAILABILITY' },
    closed:     { key: 'closed',     rgb: '239 68 68',  copy: "OFFLINE, WE'LL RESPOND THE FOLLOWING BUSINESS DAY" }
  };

  // Current date/time in Pacific time, as plain numbers
  function pacificNow() {
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      weekday: 'short', month: 'numeric', day: 'numeric', year: 'numeric',
      hour: '2-digit', minute: '2-digit', hour12: false
    });
    var p = {};
    fmt.formatToParts(new Date()).forEach(function (part) { p[part.type] = part.value; });
    var hour = parseInt(p.hour, 10) % 24; // some engines emit 24 at midnight
    return {
      weekday: p.weekday,
      month:   parseInt(p.month, 10),
      day:     parseInt(p.day, 10),
      year:    parseInt(p.year, 10),
      minutes: hour * 60 + parseInt(p.minute, 10)
    };
  }

  // Day-of-month of the Nth given weekday in a month. weekday: 0=Sun..6=Sat, month0: 0=Jan.
  function nthWeekday(year, month0, weekday, n) {
    var firstDow = new Date(Date.UTC(year, month0, 1)).getUTCDay();
    return 1 + ((weekday - firstDow + 7) % 7) + (n - 1) * 7;
  }
  // Day-of-month of the LAST given weekday in a month.
  function lastWeekday(year, month0, weekday) {
    var daysInMonth = new Date(Date.UTC(year, month0 + 1, 0)).getUTCDate();
    var lastDow = new Date(Date.UTC(year, month0, daysInMonth)).getUTCDay();
    return daysInMonth - ((lastDow - weekday + 7) % 7);
  }

  // Full-closure holidays → red
  function isClosedHoliday(t) {
    var fixed = [
      [12, 24], // Christmas Eve
      [12, 25], // Christmas Day
      [12, 31], // New Year's Eve
      [1, 1]    // New Year's Day
    ];
    for (var i = 0; i < fixed.length; i++) {
      if (t.month === fixed[i][0] && t.day === fixed[i][1]) return true;
    }
    // Thanksgiving Day — 4th Thursday of November (Thu = 4)
    if (t.month === 11 && t.day === nthWeekday(t.year, 10, 4, 4)) return true;
    return false;
  }

  // Reduced-staff holidays → amber all day
  function isLimitedHoliday(t) {
    if (t.month === 7 && t.day === 4) return true;                          // Independence Day
    if (t.month === 5 && t.day === lastWeekday(t.year, 4, 1)) return true;  // Memorial Day (last Mon of May)
    if (t.month === 9 && t.day === nthWeekday(t.year, 8, 1, 1)) return true; // Labor Day (1st Mon of Sept)
    return false;
  }

  function stateKey() {
    var t = pacificNow();
    if (isClosedHoliday(t)) return 'closed';
    if (isLimitedHoliday(t)) return 'limited';
    var isWeekday = t.weekday !== 'Sat' && t.weekday !== 'Sun';
    if (isWeekday && t.minutes >= OPEN_MIN && t.minutes < CLOSE_MIN) return 'online';
    return 'afterhours';
  }

  function compute() { return STATES[stateKey()]; }

  function apply() {
    var def = compute();
    var els = document.querySelectorAll('[data-sk-agent-status]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      el.classList.remove('sk-agent--online', 'sk-agent--afterhours', 'sk-agent--limited', 'sk-agent--closed');
      el.classList.add('sk-agent--' + def.key);
      el.style.setProperty('--sk-agent-rgb', def.rgb);
      var t = el.querySelector('[data-sk-agent-text]');
      if (t) t.textContent = def.copy;
    }
  }

  window.SK_AGENT_STATUS = { compute: compute, apply: apply };

  function start() {
    apply();
    // Re-evaluate every minute so the dot flips at open/close without a reload
    setInterval(apply, 60 * 1000);
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
